import React from 'react';
import styled from 'styled-components';
import {findCatFromOutlet} from 'rev.sdk.js/Utils/CategoryUtil';

function BrowserHeader(props) {
  const {route, cat} = props;
  let rootCat = null;
  let catObj = null;
  let defaultProductCatImg = null;
  let defaultArticleCatImg = null;

  if (route === '/products') {
    rootCat = findCatFromOutlet('categories');
    catObj = findCatFromOutlet('categories', cat);
    defaultProductCatImg = rootCat.meta_data['img_url'];
  } else if (route === '/articles') {
    rootCat = findCatFromOutlet('articleCategories');
    catObj = findCatFromOutlet('articleCategories', cat);
    defaultArticleCatImg = rootCat.meta_data['img_url'];
  } else {
    return null;
  }

  const imgUrl =
    catObj?.img_url ||
    (route === '/products' ? defaultProductCatImg : defaultArticleCatImg);

  return (
    <Wrapper className="browser-header">
      {!imgUrl ? (
        <div className="loading" />
      ) : (
        <img src={imgUrl} alt="cat-banner" />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  margin: 20px 0px;

  & div.loading,
  img {
    width: 100%;
    height: 200px;
    overflow: hidden;
    object-fit: cover;
  }

  @media (max-width: 480px) {
    & div.loading,
    img {
      height: 150px;
    }
  }
`;
export default BrowserHeader;
